<script>
import { inventoryMethods } from '@state/helpers'
import { mapGetters } from 'vuex'

export default {
  name: 'TitleCountSpentProducts',
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      warehouse_i: 'retina/inventory/warehouse_i',
      ubication_i: 'retina/inventory/ubication_i',
    }),
  },
  methods: {
    ...inventoryMethods,
    goToInventoryCountMode() {
      this.disableInventoryCountSpentProducts()
      this.enableInventoryCountMode()
    },
    goToCountReview() {
      this.setPendingResults()
      this.disableInventoryCountSpentProducts()
      this.enableInventoryCountReview()
    },
  },
}
</script>
<template>
  <b-card no-body class="p-2">
    <span class="text-primary font-weight-lighter">Lugar seleccionado:</span>
    <b-card-title>{{ warehouse_i.description }}</b-card-title>
    <b-card-sub-title class="mb-2 lead">
      {{ ubication_i ? ubication_i.name : "" }}
      <b-badge variant="primary">{{ warehouse_i.code }}</b-badge>
    </b-card-sub-title>
    <b-card-body body-class="p-0" class="p-0">
      <b-button-group class="w-100">
          <b-button
            @click="goToInventoryCountMode()"
            variant="outline-secondary"
            class="mr-1"
          >
            <i class="fas fa-chevron-left"></i>{{ ' ' }}
            <i class="fas fa-dolly-flatbed"></i> Conteo
          </b-button>
          <b-button
            @click="goToCountReview()"
            variant="outline-secondary"
          >
            <i class="fas fa-clipboard-list"></i>
            Revisar Pedido
            <i class="fas fa-chevron-right"></i>
          </b-button>
      </b-button-group>
    </b-card-body>
    <!-- <b-button  variant="outline-success" class="mb-2">
      <i class="fas fa-check"></i>
    </b-button> -->
  </b-card>
</template>
